import api from '../httpClient'

export type MentorshipGoalStatus = "Not started" | "In progress" | "Completed"

export type MentorshipGoal = {
  id: number
  title: string
  status: MentorshipGoalStatus
}

export type MentorshipDashboardResponse = {
  cohort: {
    id: string
    name: string
    start_date?: string | null
    end_date?: string | null
    role?: string | null
    mentee_label_singular?: string | null
    mentee_label_plural?: string | null
    mentor_label_singular?: string | null
    mentor_label_plural?: string | null
  } | null
  members: any[]
  checklist_items: any[]
  meetings: any[]
  goals?: MentorshipGoal[]
  errors?: {
    members?: string | null
    checklist?: string | null
    meetings?: string | null
  }
}

export type ReportSafetySignalPayload = {
  description: string
  reported_user_id?: number | null
}

const getDashboard = async (): Promise<MentorshipDashboardResponse> => {
  const resp = await api.get<MentorshipDashboardResponse>('/api/mentorship/mentee-dashboard/')
  return resp.data
}

const saveGoals = async (goals: MentorshipGoal[]): Promise<MentorshipGoal[]> => {
  const resp = await api.post<{ goals: MentorshipGoal[] }>('/api/mentorship/goals/', { goals })
  return resp.data.goals
}

const reportSafetySignal = async (payload: ReportSafetySignalPayload) => {
  const resp = await api.post('/api/mentorship/safety-signals/report/', payload)
  return resp.data
}

export const mentorship = {
  getDashboard,
  saveGoals,
  reportSafetySignal,
  // Backward compatibility for any lingering mentee-specific references
  getMenteeDashboard: getDashboard,
}
